import { useMutation } from '@apollo/client'
import { Minus, Plus } from 'lucide-react'
import { Button } from 'design-system'
import React, { FC } from 'react'
import { useDispatch } from 'react-redux'

import { gqlDisplayName } from 'shared/lib/user'

import { setBanner } from 'src/store/action-methods/banner'

import { TOGGLE_FRIENDSHIP } from 'src/graphql/user/profile'

import { UserMenuType } from './types'

interface ButtonProps {
  userProfile: Pick<UserMenuType, 'id' | 'followsUser'>
  className: string
  isOwnProfile: boolean
}

export const FollowButton: FC<ButtonProps> = ({
  userProfile,
  className,
  isOwnProfile
}) => {
  const dispatch = useDispatch()
  const [toggleFriendshipMutation] = useMutation(TOGGLE_FRIENDSHIP)
  const isFollowed = userProfile.followsUser

  const toggleFriendship = async () => {
    try {
      await toggleFriendshipMutation({
        variables: { userId: userProfile.id }
      })
      setBanner({
        open: true,
        msg: `User ${isFollowed ? 'unfollowed' : 'followed'} successfully.`,
        assertive: true
      })(dispatch)
    } catch (_) {
      setBanner({
        open: true,
        type: 'error',
        msg: `Unable to ${isFollowed ? 'Unfollow' : 'Follow'} user.`,
        assertive: true
      })(dispatch)
    }
  }

  if (isOwnProfile) {
    return null
  }

  return (
    <Button
      buttonType="primary"
      buttonSize="sm"
      className={className}
      onClick={toggleFriendship}
      leftIconSlot={isFollowed ? <Minus /> : <Plus />}
      aria-label={`${isFollowed ? 'Unfollow' : 'Follow'} ${gqlDisplayName(
        userProfile
      )}`}>
      {isFollowed ? 'Unfollow' : 'Follow'}
    </Button>
  )
}
